// extracted by mini-css-extract-plugin
module.exports = {"spinnerOverlay":"Spinner_spinnerOverlay__2iRCP","spinnerContainer":"Spinner_spinnerContainer__qpyK2","spin":"Spinner_spin__2cA5G"};